import config, { BridgeWarAvatarName } from '../config';

type HeadUrl = string;
type FigurineUrl = string;
export type BridgeWarAvatar = { lvl: [FigurineUrl, HeadUrl][]; color: string; figurine: BridgeWarAvatarName };
export type BridgeWarAvatars = Record<BridgeWarAvatarName, BridgeWarAvatar>;

function getAvatar(bridgeWarAvatarName: BridgeWarAvatarName): BridgeWarAvatar {
    return {
        lvl: [...Array(config.lvls).keys()].map((key) => [
            `${config.domain}/${config.avatarsFolder}/${bridgeWarAvatarName}/lvl-${key + 1}/${config.figurineFileName}`,
            `${config.domain}/${config.avatarsFolder}/${bridgeWarAvatarName}/lvl-${key + 1}/${config.headFileName}`,
        ]),
        color: config.colors[bridgeWarAvatarName],
        figurine: bridgeWarAvatarName,
    };
}

export const bridgeWarAvatars: BridgeWarAvatars = {
    [BridgeWarAvatarName.airgenasi]: getAvatar(BridgeWarAvatarName.airgenasi),
    [BridgeWarAvatarName.dragon]: getAvatar(BridgeWarAvatarName.dragon),
    [BridgeWarAvatarName.lycan]: getAvatar(BridgeWarAvatarName.lycan),
    [BridgeWarAvatarName.orc]: getAvatar(BridgeWarAvatarName.orc),
    [BridgeWarAvatarName.phoenix]: getAvatar(BridgeWarAvatarName.phoenix),
    [BridgeWarAvatarName.wizard]: getAvatar(BridgeWarAvatarName.wizard),
};
